
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-confirm-labadmin',
  templateUrl: './confirm-labadmin.component.html',
  styleUrls: ['./confirm-labadmin.component.scss']
})
export class ConfirmLabadminComponent implements OnInit {
  [x: string]: any;
  isDirty: any;
  isActionChecked: boolean = false;
  primaryBtnClass: string = 'primary'
  icon: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmLabadminComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (this.data.action === 'Delete' || this.data.continue === 'Delete') {
      this.icon = '/assets/icons/user_icons/Alert_Delete.svg';
    } else if (this.data.action === 'Warning') {
      this.icon = '/assets/icons/user_icons/Alert_Warning.svg';
    } else {
      this.icon = '/assets/icons/user_icons/Alert_Warning.svg';
    }
  }

  onNoClick() {
    this.isDirty = false;
    this.dialogRef.close('true');
    this.canDeactivate();
  }

  canDeactivate(): boolean {
    return true
  }

  ifExists(alert) {
    let messages = ["Permanently Delete Record", "Are you sure to De-Associate the selected location(s)?"]
    return messages.includes(alert) || alert.includes('Permanently Delete Record');
  }

  onCheckboxClick(event) {
    this.isActionChecked = event;
  }

  /** Continue stays disabled until the action checkbox is checked when acknowledgement is required. */
  isContinueDisabled(): boolean {
    if (!this.data?.action || this.data.action === 'Activate Account' || this.data.action === 'Deactivate Account') {
      return false;
    }
    const requireAck =
      this.data.requireCheckboxAcknowledge === true ||
      (typeof this.data?.message === 'string' && this.data.message.includes('offline!'));
    return requireAck && !this.isActionChecked;
  }

  getButtonText(): string {
    if (this.data.action === 'Delete') {
      return 'Delete';
    }
    return this.data.continue || 'OK';
  }

}


